export default {"src":"/_next/static/media/factsheet.10cb0b53.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};